(function($) {

    $.fn.accordion = function() {

        var elem = $(this);

        var init = function() {

            // on click of accordion trigger...
            elem.find('.js-accordion__trigger').on('click', function (evt) {
                var trigger = $(this),
                    target = $( trigger.attr('href') );

                if(target.any()) {
                    evt.preventDefault();

                    elem.find('.js-accordion__content').not(target).removeClass('accordion__content--is-active');
                    target.toggleClass('accordion__content--is-active');
                }
            });

        };

        init();
        return this;
    };

}($));
